import React, { useState } from 'react';
import {
    Modal,
    Box,
    IconButton,
    Typography,
    Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Close as CloseIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import { toast } from 'react-hot-toast';

import axios from "axios";
import { CONFIG } from "../../../../../config";
const API_HOST_CRM = CONFIG.modules["crm"].host;

const ExportTelecallerRatingSingleModal = ({ open, handleClose, handleOpen, agent }) => {
    const [fromDate, setFromDate] = useState(dayjs());
    const [toDate, setToDate] = useState(dayjs());

    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);
        const queryParams = new URLSearchParams();
        queryParams.append('from', dayjs(fromDate).format('YYYY-MM-DD'));
        queryParams.append('to', dayjs(toDate).format('YYYY-MM-DD'));
        queryParams.append('caller_id', agent.user._id);

        try {
            // crete a network request to download
            const response = await axios.get(API_HOST_CRM + `/quality-assurance/telecaller/rating/export?${queryParams}`, {
                responseType: 'arraybuffer',
            });
            //   const url = window.URL.createObjectURL(new Blob([response.data]));

            // Get filename from Content-Disposition header or use default
            const contentDisposition = response.headers['Content-Disposition'];

            console.log("Response headers", contentDisposition);
            let filename = `${agent.user.name}_uuid_${agent.user.uuid}_telecaller_ratings_${dayjs(fromDate).format('YYYY-MM-DD')}_to_${dayjs(toDate).format('YYYY-MM-DD')}.xlsx`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success('Telecallers ratings exported successfully');

            handleClose();

        } catch (error) {
            console.log(error);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
            }}>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" component="h2" mb={2}>
                    Export Ratings
                </Typography>
                <DatePicker
                    label="From Date"
                    value={fromDate}
                    onChange={(newValue) => setFromDate(newValue)}
                    sx={{ mb: 2, width: '100%' }}
                />
                <DatePicker
                    label="To Date"
                    value={toDate}
                    onChange={(newValue) => setToDate(newValue)}
                    sx={{ mb: 2, width: '100%' }}
                />
                <Button
                    variant="contained"
                    onClick={handleExport}
                    disabled={!fromDate || !toDate}
                    fullWidth
                >
                    Export
                </Button>
            </Box>
        </Modal>
    );
};

export default ExportTelecallerRatingSingleModal;
